export const ArchiveJobTemplateAction = ({ onClickSingle }) => ({
  label: "Archive",
  icon: "box-archive",
  iconStyle: "solid",
  danger: true,
  onClickSingle,
  confirm: {
    title: "Archive job template",
    message: (row) =>
      `Are you sure you want to archive the ${row.name} template?`,
    confirmLabel: "Archive",
  },
})

export const EditJobTemplateAction = ({ onClickSingle }) => ({
  label: "Edit",
  icon: "pen-to-square",
  iconStyle: "solid",
  role: "view",
  onClickSingle,
})

export const RestoreJobTemplateAction = ({ onClickSingle }) => ({
  label: "Restore",
  icon: "rotate-left",
  iconStyle: "solid",
  onClickSingle,
})
